import dateFormat from 'dateformat';

const formatDateWithFormat = (date, format) => {
    return dateFormat(date, format);
};

export default formatDateWithFormat;
